import React from 'react';
import { YouTubeIcon, InstagramIcon, FacebookIcon, LinkedInIcon } from '../icons';
import generalLogo from '../assets/LogoGeneral.svg';
import ibLogo from '../assets/IB CONTINUUM.png';
import cambridgeLogo from '../assets/CAMBRIDGE.png';
import cisLogo from '../assets/CIS MEMBER.png';
const SOCIALS = [
  { label: 'YouTube', Icon: YouTubeIcon, url: 'https://www.youtube.com/@gmisofficialchannel' },
  { label: 'Instagram', Icon: InstagramIcon, url: 'https://www.instagram.com/gmis.jakarta?igsi=Z2t6YWVsa2hoYmxt&utm_source=qr' },
  { label: 'Facebook', Icon: FacebookIcon, url: '#' },
  { label: 'LinkedIn', Icon: LinkedInIcon, url: '#' },
];

const ACCRED_LOGOS = [ibLogo, cambridgeLogo, cisLogo];

const Footer = ({ t }) => (
  /* full-width navy-deep bg */
  <div className="w-full bg-navy-deep text-white">
    {/* max-width content */}
    <div className="max-w-[1440px] mx-auto px-[120px] pt-[72px] h-[620px] box-border flex flex-col">

      {/* ── Top row ── */}
      <div className="flex items-start justify-between gap-12">

        {/* Brand */}
        <div className="flex flex-col gap-3.5">
          <div className="flex items-center gap-4">
            <img src={generalLogo} alt="GMIS Logo" className="h-[72px] w-auto  " />
          </div>
          <div className="text-[11.5px] font-semibold tracking-[0.16em] text-gold">{t.est}</div>
        </div>

        {/* Contact */}
        <div className="flex flex-col gap-2.5 text-sm leading-[1.55] text-white/90">
          <div className="max-w-[320px]">Jl. HBR Motik D6 No. 1, Kemayoran, Central Jakarta, DKI Jakarta</div>
          <div>+62 21 6586 5667</div>
          <div>admissions@gmis.sch.id</div>
        </div>

        {/* Social icons */}
        <div className="flex gap-2.5 rounded-[10%]">
          {SOCIALS.map(({ label, Icon, url }) => (
            <a
              key={label}
              href={url}
              target="_blank"
              rel="noopener noreferrer"
              aria-label={label}
              className="w-11 h-11 border border-white/35 flex items-center justify-center rounded-[8px] hover:border-gold"
            >
              <Icon />
            </a>
          ))}
        </div>
      </div>

      {/* ── Divider ── */}
      <div className="h-px bg-white/[0.18] my-12" />

      {/* ── Link columns ── */}
      <div className="grid grid-cols-4 gap-12">

        {/* Quick Links */}
        <div className="flex flex-col">
          <div className="text-[12px] font-bold tracking-[0.16em] uppercase text-gold pb-[14px]">{t.fQuick}</div>
          {t.quick.map((label) => (
            <a key={label} className="ulink flex items-center min-h-[36px] text-[15px] text-white/90" href="#">
              {label}
            </a>
          ))}
        </div>

        {/* Academics */}
        <div className="flex flex-col">
          <div className="text-[12px] font-bold tracking-[0.16em] uppercase text-gold pb-[14px]">{t.fAcad}</div>
          {t.acad.map((label) => (
            <a key={label} className="ulink flex items-center min-h-[36px] text-[15px] text-white/90" href="#">
              {label}
            </a>
          ))}
        </div>

        {/* Visiting Hours */}
        <div className="flex flex-col">
          <div className="text-[12px] font-bold tracking-[0.16em] uppercase text-gold pb-[14px]">{t.fHours}</div>
          <div className="flex flex-col border-t border-white/[0.18] text-[15px] text-white/90">
            <div className="flex justify-between py-3 border-b border-white/[0.18]">
              <span>{t.monFri}</span><span className="font-semibold">7:30 - 16:00</span>
            </div>
            <div className="flex justify-between py-3 border-b border-white/[0.18]">
              <span>{t.sat}</span><span className="font-semibold">9:00 - 12:00</span>
            </div>
          </div>
          <div className="pt-[14px] text-sm text-white/90">{t.fWa}: +62 811-1180-1448</div>
        </div>

        {/* Accreditations */}
        <div className="flex flex-col">
          <div className="text-[12px] font-bold tracking-[0.16em] uppercase text-gold pb-[14px]">{t.fAccred}</div>
          <div className="flex gap-2.5">
            {ACCRED_LOGOS.map((logo, i) => (
              <div
                key={i}
                className="flex-1 h-[52px] bg-white rounded-[8px] flex items-center justify-center p-2"
              >
                <img src={logo} alt="Accreditation" className="max-h-full max-w-full object-contain" />
              </div>
            ))}
          </div>
          <div className="pt-5 flex gap-3">
            <div className="px-3 py-1.5 bg-white/10 rounded-full text-gold text-[9px] font-medium tracking-wide">
              IB World School
            </div>
            <div className="px-3 py-1.5 bg-white/10 rounded-full text-gold text-[9px] font-medium tracking-wide">
              Cambridge Exam Centre
            </div>
          </div>
        </div>
      </div>

      {/* ── Bottom bar ── */}
      <div className="mt-auto h-[88px] flex items-center justify-between border-t border-white/[0.18] text-[13px] text-white/[0.78]">
        <div className="flex items-center gap-7">
          <span>{t.copy}</span>
          <a className="ulink" href="#">{t.privacy}</a>
          <a className="ulink" href="#">{t.terms}</a>
          <a className="ulink" href="#">{t.sitemap}</a>
        </div>
        <a
          className="btn flex items-center h-[42px] px-6 rounded-[3px] bg-gold text-navy-deep text-[12.5px] font-bold tracking-widest uppercase"
          href="#"
        >
          {t.enquiry}
        </a>
      </div>
    </div>
  </div>
);

export default Footer;
